
import React from "react";
import FeedbackList from "@/components/feedback/FeedbackList";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePermissions } from "@/context/PermissionsContext";

const Feedback = () => {
  const isMobile = useIsMobile();
  const { hasPermission } = usePermissions();
  const canAccessFeedback = hasPermission("feedback", "read");

  if (!canAccessFeedback) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <p className="text-muted-foreground">Je hebt onvoldoende rechten om deze pagina te bekijken</p>
      </div>
    );
  }

  return (
    <div className={`space-y-4 ${isMobile ? 'pb-16' : 'space-y-6'}`}>
      <div>
        <h1 className={`${isMobile ? 'text-xl' : 'text-2xl'} font-bold`}>Feedback</h1>
        {!isMobile && (
          <p className="text-muted-foreground">
            Deel je feedback, ideëen en vragen over de applicatie
          </p>
        )}
      </div>

      <FeedbackList />
    </div>
  );
};

export default Feedback;
